export default __webpack_public_path__ + "static/media/picture-placeholder.f9916095.svg";